import DeleteIcon from "@mui/icons-material/Delete";
import { Button, CardHeader, CircularProgress, IconButton, Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import Alert from "@mui/material/Alert";
import axios from "axios";
import moment from "moment";
import * as React from "react";
import { NavLink } from "react-router-dom";
import { Config } from "../../config/config";
import { Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";

interface Props {
    activeUser: any;
    activeEnv: any;
    classes: any;
    form: any;
}

interface State {
    tasks: any[];
    loaded: boolean;
}

export class Tasks extends React.Component<Props, State> {

    constructor(props) {
        super(props);

        this.state = {
            tasks: [],
            loaded: false,
        };

        document.title = Helpers.documentTitle("Tasks");
    }

    componentDidMount() {
        this.fetchData();
    }

    headers() {
        return {
            headers: { Authorization: Helpers.getSessionId() },
            timeout: 30000
        }
    }

    async fetchData() {
        try {
            const response = await axios.get(`${Config.getInstance.apiUrl}/api/tasks`, this.headers());
            this.setState({
                tasks: response.data.tasks,
                loaded: true,
            });
        } catch (e) {
            PopupMessage.error(e.response.data.message);
        }
    }

    formatDate(date: string) {
        return moment(date).utc().format("DD.MM.YYYY HH:mm");
    }

    async deleteTask(e, taskId: string) {
        e.preventDefault();

        if (confirm("Are you sure?")) {
            try {
                const response = await axios.delete(`${Config.getInstance.apiUrl}/api/tasks/${taskId}`, {
                    headers: {
                        Authorization: Helpers.getSessionId(),
                        env: this.props.activeEnv,
                    },
                });

                const tempTaskList = this.state.tasks;
                const taskIndex = tempTaskList.findIndex(task => task.id === taskId);

                tempTaskList.splice(taskIndex, 1);

                this.setState({
                    tasks: tempTaskList,
                })

                PopupMessage.success("Task deleted");
            } catch (error) {
                PopupMessage.error("Something went wrong");
            }
        }
    }

    renderTableContent() {
        if (!this.state.loaded) {
            return <TableRow key="loading-row">
                <TableCell colSpan={8}>
                    {Helpers.renderSkeletonRows(5, 50)}
                </TableCell>
            </TableRow>
        }

        if (this.state.tasks.length === 0) {
            return <TableRow key="records_not_found">
                <TableCell colSpan={8}>
                    <Alert severity="info">No Tasks Found</Alert>
                </TableCell>
            </TableRow>
        }

        return this.state.tasks.map(record => (
            <TableRow key={"event-" + record.key}>
                <TableCell>{record.key}</TableCell>
                <TableCell>{record.start_at ? this.formatDate(record.start_at) : "-"}</TableCell>
                <TableCell>{record.expire_at ? this.formatDate(record.expire_at) : "-"}</TableCell>
                <TableCell>{record.created_at ? this.formatDate(record.created_at) : "-"}</TableCell>
                <TableCell>
                    <IconButton aria-label="Delete" onClick={(e) => this.deleteTask(e, record.id)} size="small">
                        <DeleteIcon fontSize="inherit"/>
                    </IconButton>
                </TableCell>
            </TableRow>
        ));
    }

    render() {
        return (
            <div className="contentPadding">
                <Paper elevation={0}>
                    <CardHeader
                        title="Tasks"
                        action={
                            <React.Fragment>
                                <NavLink to="/tasks/new"style={{ textDecoration: "none" }}>
                                    <Button disableElevation color="primary" size="small" variant="contained">
                                        Add new
                                    </Button>
                                </NavLink>
                            </React.Fragment>
                        }
                    />

                    <Table className="min-table-size">
                        <TableHead>
                            <TableRow>
                                <TableCell>Key</TableCell>
                                <TableCell>Start</TableCell>
                                <TableCell>End</TableCell>
                                <TableCell>Created</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.renderTableContent()}
                        </TableBody>
                    </Table>
                </Paper>
            </div>
        );
    }
}
